<div>
  <div class="modal-header py-2">
    <div class="d-flex">
      <h5 class="mr-3" id="modal-basic-title">
        <strong
          ><i
            class="ri-arrow-left-line mr-2 mt-2"
            (click)="closeModal()"
            style="cursor: pointer"
          ></i
          >Notifications</strong
        >
      </h5>
    </div>

    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true">&times;</span>
      <!-- clear All -->
    </button>
  </div>
  <div class="modal-body m-0 p-0">
    <div class="text-right pt-1 mr-3">
      <small
        class="clearAll"
        *ngIf="notificationsList.length > 0"
        (click)="deleteAll()"
        >clearAll</small
      >
    </div>
    <!-- <div class="card mb-1" *ngFor="let each of notificationsList">
            <p class="m-0" (click)="navigateDetails(each)"> <b>Invoice no : {{each?.invoice_number}}</b></p>
            <small>Printed By : {{each?.print_by}}</small>
        </div> -->
    <div class="bg-gray custom-toas" *ngFor="let each of notificationsList">
      <div class="p-3 mt-2">
        <div class="row mb-2">
          <div class="col-md-6">
            <div>
              <small class="tax-invoice">{{ each?.invoice_category }}</small>
            </div>
          </div>

          <div class="col-md-6 text-right">
            <div>
              <small>{{ each?.creation | date : "MMM d, y h:mm a" }}</small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-9">
            <div class="d-flex">
              <div>
                <i
                  *ngIf="each.record_type == 'Create'"
                  class="ri-checkbox-circle-fill crct"
                ></i>
                <i
                  *ngIf="each.record_type == 'Delete'"
                  class="ri-close-circle-fill remove"
                ></i>
              </div>
              <div>
                <h6 class="m-0">
                  Invoice No : <b>{{ each?.invoice_number }}</b>
                </h6>
                <small>
                  Printed By : <b>{{ each?.print_by }}</b></small
                >
              </div>
            </div>
          </div>
          <div class="col-md-3 my-auto">
            <div class="text-right">
              <span class="badge badge-secondary" (click)="deleteOne(each)"
                >Clear</span
              >
              <!-- <i class="ri-delete-bin-line text-white delete" (click)="deleteOne(each)"></i> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
